import './style.scss'
export default function InfoBlock4() {
    return <div className="info-block-4">
        <div className="info-block-4__wrapper container">
            <h1 className="info-block-4__title title" data-aos="fade-up">From Canadian developers to Canadian people</h1>
            <p data-aos="fade-up">Our team unites specialists in finance, IT and law, which ensures a comprehensive approach to projects of any complexity. <br/> <br/>

                We are constantly improving our expertise by participating in specialized conferences and cooperating with leading educational centers. <br/> <br/>

                If you are ready to take full advantage of digital progress, we will be your reliable guide in the world of financial innovation.</p>
        </div>
    </div>
}